export default "assets/images/full-logo-72d38323.png";